import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ExecutionsMyTasksList from '../../../../../components/Tasks/TasksExecsLists/ExecutionsMyTasksList';

const routes = [
  {
    path: '/my-tasks/executions',
    exact: true,
    component: () => <Redirect to="/my-tasks/executions/active" />
  },
  {
    path: '/my-tasks/executions/all',
    component: ExecutionsMyTasksList,
    props: { queryParamsStatic: { status: null } }
  },
  {
    path: '/my-tasks/executions/active',
    exact: true,
    component: ExecutionsMyTasksList,
    props: { queryParamsStatic: { status: '1,2,3,7' } }
  },
  {
    path: '/my-tasks/executions/active/in-work',
    component: ExecutionsMyTasksList,
    props: { queryParamsStatic: { status: '1' } }
  },
  {
    path: '/my-tasks/executions/active/wait-checked',
    component: ExecutionsMyTasksList,
    props: { queryParamsStatic: { status: '2' } }
  },
  {
    path: '/my-tasks/executions/active/remake',
    component: ExecutionsMyTasksList,
    props: { queryParamsStatic: { status: '3' } }
  },
  {
    path: '/my-tasks/executions/finished',
    exact: true,
    component: ExecutionsMyTasksList,
    props: { queryParamsStatic: { status: '4,5,6' } }
  },
  {
    path: '/my-tasks/executions/finished/confirm',
    component: ExecutionsMyTasksList,
    props: { queryParamsStatic: { status: '4' } }
  },
  {
    path: '/my-tasks/executions/finished/cancel',
    component: ExecutionsMyTasksList,
    props: { queryParamsStatic: { status: '5' } }
  },
  {
    path: '/my-tasks/executions/finished/refuse',
    component: ExecutionsMyTasksList,
    props: { queryParamsStatic: { status: '6' } }
  },
  {
    path: '/my-tasks/executions/dispute',
    component: ExecutionsMyTasksList,
    props: { queryParamsStatic: { status: '7' } }
  },
  {
    path: '/my-tasks/executions/finished/cancel-by-task-owner',
    component: ExecutionsMyTasksList,
    props: { queryParamsStatic: { status: '8' } }
  }
];

const RouteWithSubRoutes = (route, props) => (
  <Route
    path={route.path}
    exact={route.exact || false}
    render={() => (
      <route.component {...props} {...route.props} routes={route.routes} />
    )}
  />
);

// eslint-disable-next-line react/prefer-stateless-function
class MyTasksCommon extends Component {
  render() {
    return (
      <Switch>
        {routes.map(route => (
          <RouteWithSubRoutes
            key={`route${route.path}`}
            {...route}
            props={{ ...this.props, ...route.props }}
          />
        ))}
      </Switch>
    );
  }
}

export default MyTasksCommon;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/ExecutionsMyTasksList/ExecutionsMyTasksList.js